import script from "./MyReservations.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyReservations.vue?vue&type=script&setup=true&lang=ts"

import "./MyReservations.vue?vue&type=style&index=0&id=282c81ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282c81ae"]])

export default __exports__